import { Fragment, useEffect, useState } from 'react'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, Typography, useTheme } from '@mui/material'
import { CAREER_MENTOR_MESSAGE_TEMPLATE } from '@/data/services/career-mentor/career-mentor-service'
import { i18nTranslationHelper } from '@/i18n'
import { AnalyticsEventName, AnalyticsTracker } from '@/infra/tracking'
import careerMentorAvatar from '@images/career-mentor-avatar.svg'
import FlowModal from './flow-modal'

export default function CareerMentorSearchBarCard() {
  const t = i18nTranslationHelper.getTComponents
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    AnalyticsTracker.trackEvent(AnalyticsEventName.CAREER_MENTOR_TRIGGER_VIEW, {
      location: 'search-bar'
    })
  }, [])

  const handleOpen = () => {
    AnalyticsTracker.trackEvent(AnalyticsEventName.CAREER_MENTOR_TRIGGER_CLICKED, {
      location: 'search-bar'
    })
    setOpen(true)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleOpen()
    }
  }

  return (
    <Fragment>
      <Box
        role="button"
        tabIndex={0}
        aria-label={t('careerMentorCard.ctaAriaLabel')}
        onClick={handleOpen}
        onKeyDown={handleKeyDown}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: '16px',
          height: '64px',
          borderRadius: '16px',
          cursor: 'pointer',
          overflow: 'visible',
          background: 'linear-gradient(127deg, #D1EAF2 12.5%, #FEF0C7 100%)',
          outline: 'none',
          '&:hover': { filter: 'brightness(0.97)' },
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2
          }
        }}
      >
        <Box component="img" src={careerMentorAvatar} alt="" aria-hidden="true" />

        <Box sx={{ flex: 1, px: '16px' }}>
          <Typography fontWeight={700} color={theme.palette.grey[900]}>
            {t('careerMentorCard.searchBarTitle')}
          </Typography>

          <Typography color={theme.palette.grey[700]}>
            {t('careerMentorCard.searchBarDescription')}
          </Typography>
        </Box>

        <ChevronRightIcon sx={{ color: theme.palette.text.primary, flexShrink: 0 }} />
      </Box>

      {open && (
        <FlowModal
          open={open}
          onClose={() => setOpen(false)}
          templateName={CAREER_MENTOR_MESSAGE_TEMPLATE.CONTACT_REQUEST}
          location="search-bar"
        />
      )}
    </Fragment>
  )
}
